module.exports = __webpack_public_path__ + "plan-gear.3yfDdaTS.svg";